import {Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, ViewEncapsulation} from "@angular/core";
import {DataTableField} from "./dataTableField.interface";
import {ConfirmationService} from "primeng/components/common/api";
import {DataTableCustomButton} from "./dataTableCustomButton.interface";
import {DataTableService} from "./dataTable.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {DateService} from "../../../../services/application/date.service";
import {AuthService} from "../../../../services/user/auth.service";
import {CalendarTranslateService} from "../../services/calendarTranslate.service";
import {Permission, PermissionConfigurationBase} from "../../../../models/permission.model";
import {PermsService} from "../../../../services/utils/perms.service";
import {ApiMethods} from "../../../../models/permission.model";

@Component({
  selector: 'kv-datatable',
  // template: `
  //   <div class="clearfix"></div>
  //   <div class="ui-g">
  //     <div class="ui-g-12">

  //       <!-- <div class="card card-w-title"> </div> -->
  //       <h2>{{sectionTitle}}</h2>
        
  //       <div class="ui-g-12" style="color:#20417b;">
  //         <b>{{this.items != null ? this.items.length.toString(): "0"}}</b>&nbsp;{{'common.results' | translate}}
  //       </div>
  //       <hr style="display: block; height: 1px; border-top: 1px solid #dddddd;"/>
  //       <div class="ui-g-12">
  //         <div class="ui-g-4" style="vertical-align: bottom;padding-bottom: 10px; padding-top: 10px;">
  //           <div class="ui-g-5">
  //             <button *ngIf="allowsMultiSelection" 
  //                     (click)="onSelectAll()" 
  //                     [disabled]="this.items == null || this.items.length == 0" 
  //                     <!--class="rowButton"-->
  //                     style="height: 40px;"
  //                     pButton 
  //                     type="button" 
  //                     label="{{'common.select_all' | translate}}">
  //             </button>
  //           </div>
  //           <div class="ui-g-5">
  //             <button *ngIf="allowsMultiSelection" 
  //                   (click)="onUnselectAll()" 
  //                   [disabled]="this.items == null || this.items.length == 0" 
  //                   <!--class="rowButton"-->
  //                   style="height: 40px;"
  //                   pButton 
  //                   type="button" 
  //                   label="{{'common.unselect_all' | translate}}"></button>
  //           </div>
  //         </div>
  //         <div class="ui-g-2"></div>
  //         <div *ngFor="let button of customButtons" class="ui-g-1" style="
  //         float: right;
  //         display:inline;
  //         text-align:right;
  //         padding-bottom: 10px; 
  //         padding-top: 10px;">
  //           <button
  //             [disabled]="(selectedItemList.length == 0 && !button.isAlwaysEnabled)"
  //             type="button"
  //             pButton
  //             [CheckPermissions]="button.checkPerms"
  //             [class]="(button.class) ? button.class : 'k-generic-btn'"
  //             [label]="button.label"
  //             [icon]="button.icon"
  //             style="padding-right: 10px;"
  //             (click)="customButtonClick(button.callbackname)">
  //           </button>
  //         </div>
  //         <div class="ui-g-3" style="float: right; text-align:right;padding-bottom: 10px; padding-top: 10px;display: inline;">
  //           <button *ngIf="addButton && permissionPOST" class="k-generic-btn" type="button" pButton icon="fa fa-plus" (click)="addItem()" [label]="addButton"
  //                   ></button>
  //         </div>
          
  //       </div>
  //       <div class="clearfix"></div>
  //       <div [hidden]="!filterable" class="ui-widget-header" style="padding:4px 10px;border-bottom: 0 none;background-color: gray !important;">
  //         <i class="fa fa-2x fa-search" style="margin:4px 4px 0 0;color: #ffffff;"></i>
  //         <input #gb type="text" pInputText style="height:30px;width: 92%;font-size:15px;" placeholder="Global filter">
  //       </div>

  //       <p-dataTable
  //         [reorderableColumns]="true"
  //         [value]="items"
  //         [(selection)]="selectedItemList"
  //         [responsive]="true"
  //         [paginator]="true"
  //         [rows]="numRowsPerPage"
  //         [globalFilter]="gb"
  //         [editable]="editable"
  //         [groupField]="(groupedRowsBy) ? groupedRowsBy.id : null"
  //         [rowGroupMode]="(groupedRowsBy) ? 'subheader' : null"
  //         [expandableRowGroups]="(groupedRowsBy) ? 'true' : null"
  //         #dt
  //       >
  //         <!-- <p-header>{{listTitle}}</p-header> -->
  //         <ng-template
  //           pTemplate="rowgroupheader"
  //           *ngIf="groupedRowsBy"
  //           let-rowData
  //           let-rowIndex
  //         >{{rowData[groupedRowsBy.id]}}
  //         </ng-template>
  //         <p-column
  //           *ngIf="1 == 0"
  //           styleClass="col-button"
  //           [style]="{'width':'45px'}"
  //         >
  //           <ng-template let-item="rowData" pTemplate="body">
  //             <button type="button" pButton (click)="onDeleteInline.emit(item)" icon="fa fa-trash"></button>
  //           </ng-template>
  //         </p-column>

          

  //         <p-column
  //           *ngIf="showSelectionCheckbox && this.items != null && this.items.length > 0"
  //           styleClass="col-button"
  //           [style]="{'width':'45px'}"
  //         >
  //           <ng-template let-item="rowData" let-i="rowIndex" pTemplate="body">
  //             <i *ngIf="item.checked" style="background-color: #fec65c; color: white;"  class="fa fa-fw fa-check kvCheckbox " (click)="this.onSelection(i, item)"></i>
  //             <i *ngIf="!item.checked" class="fa fa-fw kvCheckbox " (click)="this.onSelection(i, item)"></i>
  //           </ng-template>
  //         </p-column>

  //         <p-column
  //           *ngFor="let btn of customInlineButtons"
  //           styleClass="col-button"
  //           [style]="{'width':'45px'}"
  //         >
  //           <ng-template let-item="rowData" pTemplate="body">
  //             <button type="button" pButton
  //                     (click)="this.onCustomInlineButton.emit({ callbackName: btn.callbackname, item: item });"
  //                     [icon]="btn.icon"></button>
  //           </ng-template>
  //         </p-column>

  //         <p-column
            
  //           *ngFor="let title of titles"
  //           [style]="{'text-align': (title.filterType == 'number' || title.filterType == 'numberHighlighted') ? 'right' : 'left'}"
  //           [field]="title.id"
  //           [header]="title.label | translate"
  //           [sortable]="!title.notSortable"
  //           [filter]="title.filterable || filterable"
  //           filterPlaceholder="Search"
  //           [editable]="title.editable"
  //           [styleClass]="getPatchClass(title)"
  //         >
  //           <!--- FIXME: Dropdown suffers a prime-ng's bug: https://github.com/primefaces/primeng/issues/193 Can prime-ng be upgraded?-->
  //           <!--  dt.filter($event.value,col.field,"equals") -->
  //           <ng-template *ngIf="title.filterType=='combo'" pTemplate="filter" let-col>
  //             <p-dropdown
  //               [options]="title.comboOptions"
  //               [style]="{'width':'100%'}"
  //               (onChange)="dt.filter($event.value,col.field,'equals')"
  //               styleClass="ui-column-filter"></p-dropdown>
  //           </ng-template>
            
  //           <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType == 'number'">
  //             {{item[col.field] | number: evaluateDecimals(title) }}
  //           </ng-template>
  //           <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType == 'numberHighlighted'">
  //             <div [ngStyle]="{'font-weight': 'bold', 'color': item[col.field] >= 0 ? 'green' : 'red'}" >{{item[col.field] | number:'1.1-1'}}</div>
  //           </ng-template>
            

  //           <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType=='date'">
  //             {{item[col.field] | date: this.srvCalTranslate.pcalendarTranslate.dateFormatFilter }}
  //           </ng-template>
  //           <ng-template *ngIf="title.filterType=='checkbox'" pTemplate="filter" let-col>

  //           </ng-template>
  //           <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType=='checkbox'">
  //             <input type="checkbox" class="dataTableCheckBox" disabled readonly checked="checked"
  //                    *ngIf="item[col.field]=='0'">
  //             <input type="checkbox" class="dataTableCheckBox" disabled readonly *ngIf="item[col.field]=='1'">
  //           </ng-template>


  //           <ng-template let-col let-item="rowData" pTemplate="editor" *ngIf="title.filterType=='date'">
  //             <p-calendar
  //               formControlName="item[col.field]"
  //               *ngIf="title.validator=={} && this.srvCalTranslate.pcalendarTranslate"
  //               [readonlyInput]="true"
  //               [dateFormat]="this.srvCalTranslate.pcalendarTranslate.dateFormat"
  //               [locale]="this.srvCalTranslate.pcalendarTranslate"
  //             ></p-calendar>
  //             <p-calendar
  //               *ngIf="title.validator.type=='date' && this.srvCalTranslate.pcalendarTranslate"
  //               [readonlyInput]="false"
  //               [dateFormat]="this.srvCalTranslate.pcalendarTranslate.dateFormat"
  //               [(ngModel)]="item[col.field]"
  //               [locale]="this.srvCalTranslate.pcalendarTranslate"
  //             ></p-calendar>
  //           </ng-template>
  //         </p-column>

  //         <p-column

  //           *ngIf="editable"
  //           styleClass="col-button"
  //           [style]="{'width':'45px'}"
  //         >
  //           <ng-template let-item="rowData" pTemplate="body">
  //             <button type="button" pButton (click)="onEditInlineLocal(item);"
  //                     icon="fa fa-save"></button>
  //           </ng-template>
  //         </p-column>
  //         <p-column

  //           *ngIf="editButton"
  //           styleClass="col-button"
  //           [style]="{'width':'45px'}"
  //         >
  //           <ng-template let-item="rowData" pTemplate="body">
  //             <button *ngIf="permissionPUT" type="button" pButton (click)="this.selectedItem = item; this.editItem();"
  //                     icon="fa fa-pencil"
  //                     ></button>
  //           </ng-template>
  //         </p-column>
  //         <p-column
  //           *ngIf="deleteButton"
  //           styleClass="col-button"
  //           [style]="{'width':'45px'}"
  //         >
  //           <ng-template let-item="rowData" pTemplate="body">
  //             <button *ngIf="permissionDELETE" type="button" pButton (click)="this.selectedItem = item; this.deleteItem();"
  //                     icon="fa fa-trash"
  //                     ></button>
  //           </ng-template>
  //         </p-column>
  //       </p-dataTable>

  //       <p-dialog
  //         *ngIf="srvDataTable.get(id).showDetail"
  //         [width]="600"
  //         [height]="popupHeight"
  //         [(visible)]="srvDataTable.get(id).showDetail"
  //         [header]="detailSelected"
  //         [responsive]="true"
  //         showEffect="fade"
  //         [modal]="true"
  //         (onAfterHide)="onCancelDetail.emit();"
  //       >
  //         <ng-content></ng-content>
  //       </p-dialog>

  //     </div>
  //   </div>

  // `,
  styles: [`
    th.bugDropdownPatch {
      overflow: visible !important;
    }
    
    th.bugTooLargeColumn {
      width: 75px;
    }
    
    p-dialog .ui-dialog .ui-dialog-content{
      overflow: visible !important;
    }

    .bugCalendarPatch {
      overflow: visible !important;
    }

    .rowButton {
      background-color: transparent !important;
      border-color: transparent !important;
      color: gray !important;
      font-weight: bold;
      font-size: 14px;
    }
        
    .kvDatatableRoundedInlineButton {
      background: #fec65c !important;
      border: solid 1px #fec65c !important;
      border-radius: 20px;
    }
    
    .kvCheckbox {
      background-color: white;
      border: 1px solid #cacece;
      box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05);
      width: 35px;
      height: 35px;
      border-radius: 3px;
      display: inline-block;
      position: relative;
      text-align: center;
      vertical-align: middle;
      padding: 9px;
    }

    /* da cancellare */
    .kvDatatableRoundedButton {
      width: 100%;
      height: 40px;
      padding:5px;
      border:1px solid #fff !important;
      background-color: #fec65c !important;
      color: #ffffff !important;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 1.11;
      border-radius: 100px;
    }
    
    
    .kvDatatableRoundedButton:hover {
      border: #fec65c 1px solid !important;
      background-color: #ffffff !important;
      color: #fec65c !important;
    }
    
    .kvDatatableRoundedButton:disabled {
      border: gray 1px solid;
      background-color: white !important;
      color: gray !important; 
    }
    
    .kvDatatableRoundedButton:disabled:hover {
    
      border: gray 1px solid !important;
      background-color: white !important;
      color: gray !important;
    }

    .kvDatatableRoundedInlineButton:hover {
      border: #fec65c 1px solid !important;
      background-color: #ffffff !important;
      color: #fec65c !important;
    }

    .kvDatatableRoundedInlineButton:disabled {
      border: gray 1px solid;
      background-color: white !important;
      color: gray !important;
    }

    .kvDatatableRoundedInlineButton:disabled:hover {

      border: gray 1px solid !important;
      background-color: white !important;
      color: gray !important;
    }

    kv-datatable .ui-datatable .ui-datatable-thead > tr > th,
    kv-datatable .ui-datatable .ui-datatable-tfoot > tr > td,
    kv-datatable .ui-datatable .ui-datatable-data > tr > td {
      border: none !important;
    }

    kv-datatable .ui-widget-content {
      border: none !important;
    }

    kv-datatable .ui-widget-header {
      background: gray !important;
      border-radius: 5px 5px 0px 0px !important;
    }

    kv-datatable .ui-datatable-thead > tr > th {
      background-color: gray !important;
      color: white !important;
      font-weight: bold !important;
    }

    kv-datatable .ui-datatable .ui-datatable-thead > tr > th:first-child {
    /*border-radius: 5px 0px 0px 0px !important;*/
    }

    kv-datatable .ui-datatable .ui-datatable-thead > tr > th:last-child {
      /*border-radius: 0px 5px 0px 0px !important;*/
    }
  `],
  templateUrl: 'dataTable.component.html',
  styleUrls: ['dataTable.component.css'],
  providers: [ TranslateService ],
  encapsulation: ViewEncapsulation.None
})


export class DataTableComponent implements OnInit, OnChanges {
  selectedItem: any;
  selectedItemList: any[];
  detailSelected: string;

  permissionDELETE: boolean = true;
  permissionPUT: boolean = true;
  permissionPOST: boolean = true;

  constructor(private confirmationService: ConfirmationService,
              public srvDataTable: DataTableService,
              private translate: TranslateService,
              private srvDate: DateService,
              private srvAuth: AuthService,
              private srvCalTranslate: CalendarTranslateService,
              public srvPerms: PermsService,
              public zone: NgZone) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

        this.translate.reloadLang(event.lang)

    })

  }



  ngOnInit(): void {
    console.log('datatable init ID=', this.id, this.items)
    this.selectedItemList = [];
    this.items.forEach(element => {
      element.checked = false;
    });


  }


  check($event, col) {
    console.log($event.value, col.field, col.filterMatchMode)

    // dt.filter($event.value,col.field,col.filterMatchMode)
  }

  evaluateDecimals(title: DataTableField) {
    return '1.'.concat(title.decimals ? title.decimals.concat('-').concat(title.decimals) : '1-1');
  }

  ngOnChanges(changes) {
    console.log('datatable changes ID=', this.id, this.items)
    if (changes.permissionSchema && changes.permissionSchema.currentValue) {
      this.srvPerms.get(changes.permissionSchema.currentValue.ms_base).subscribe();


      if (changes.permissionSchema) {
        console.log('permissionSchema', changes.permissionSchema.currentValue)


        this.srvPerms.get(changes.permissionSchema.currentValue.ms_base).subscribe(() => {
          const permission: Permission = this.srvPerms.permissions[changes.permissionSchema.currentValue.ms_base].find(function (e) {
            if (e.operationName === changes.permissionSchema.currentValue.operation) { return e; }
          });

          if (permission && permission != null) {
            this.permissionPOST = permission.allowsPOST
            this.permissionPUT = permission.allowsPUT
            this.permissionDELETE = permission.allowsDELETE
          }
        })

      }
    }
    if (changes.items && changes.items.currentValue) {
      this.selectedItemList = [];
    }
  }

  deleteItem() {
    console.log("delete item");
    if (this.selectedItem) {
      console.log(this.selectedItem)
      this.translate.get(['dataTable.deleteConfirmDescription', 'dataTable.deleteConfirmHeader']).subscribe((res) => {
        console.log("delete item - 2");
        this.confirmationService.confirm({
          message: res['dataTable.deleteConfirmDescription'],
          header: res['dataTable.deleteConfirmHeader'],
          icon: 'fa fa-trash',
          accept: () => {
            this.onDelete.emit(this.selectedItem);
          },
          reject: () => {
            console.log("reject");
          }
        });

      });


    }
  }

  editItem() {
    console.log("edit");
    console.log(this.selectedItem);
    if (this.selectedItem) {
      if (this.showPopupOnAddEdit) this.srvDataTable.get(this.id).showDetail = true;
      this.detailSelected = this.editButton;
      this.onEdit.emit(this.selectedItem);
    }
  }

  addItem() {
    if (this.showPopupOnAddEdit) this.srvDataTable.get(this.id).showDetail = true;
    this.detailSelected = this.addButton;
    this.onAdd.emit(null);
  }

  customButtonClick(callbackName) {
    this.onCustomButton.emit({
      callbackName: callbackName,
      selectedItem: this.selectedItemList[0]
    });
  }

  getPermissionSchema(api: ApiMethods) {
    return Object.assign({}, this.permissionSchema, {method: api})
  }

  getPatchClass(title) {
    switch (title.filterType) {
      case 'combo':
        return 'bugDropdownPatch';
      case 'date':
        return 'bugCalendarPatch';
      case 'tooLarge':
        return 'bugTooLargeColumn';
    }
    return null;
  }

  onEditInlineLocal(item) {
    console.log("dataTable -- item");

    console.log(item);

    if (this.useValidators) {
      if (this.srvDate.validateRange(item.date_start, item.date_end)) {
        this.onEditInline.emit(item);
      }
    } else {
      this.onEditInline.emit(item);
    }
  }

  onSelection(index, item) {
    item.checked = !item.checked;
    let status : boolean = item.checked;
    let i: number = this.items.indexOf(item);
    if (!this.allowsMultiSelection) {
      this.items.forEach(it => {
        it.checked = false;
      });
      this.items[i].checked = status;
      this.selectedItemList = status ? [ this.items[i] ] : [];
      this.selectedItem = status ? this.selectedItemList[0] : null;
      this.onItemClick.emit(this.selectedItem);
    }
    else {

      let i_sel : number = this.selectedItemList.indexOf(item);
      if (i_sel == -1)
        this.selectedItemList.push(this.items[i]);
      else
        this.selectedItemList.splice(i_sel, 1);

    }
    console.log(this.selectedItemList);

  }

  onSelectAll() {
    this.selectedItemList = [];

    let i: number = 0;
    this.items.forEach(it => {
      it.checked = true;
      this.selectedItemList.push(it);
      i++;
    });

  }

  onUnselectAll() {
    this.items.forEach(it => {
      it.checked = false;
    });
    this.selectedItemList = [];
  }

  @Input() sectionTitle: string;
  @Input() listTitle: string;
  @Input() numRowsPerPage: number = 25;
  @Input() titles: DataTableField[];
  @Input() groupedRowsBy: DataTableField;
  @Input() items: any[];
  @Input() addButton: string;
  @Input() editButton: string;
  @Input() deleteButton: string;
  @Input() customButtons: DataTableCustomButton[];
  @Input() customInlineButtons: DataTableCustomButton[];
  @Input() id: string = "DTID";
  @Input() showDetail: boolean; //FIXME: REMOVE THIS INPUT
  @Input() popupHeight: string = "auto";
  @Input() filterable: boolean = true;
  @Input() editable: boolean = false;
  @Input() deletable: boolean = false;
  @Input() useValidators: boolean = false;
  @Input() permissionSchema: PermissionConfigurationBase = null;
  @Input() showSelectionCheckbox: boolean = true;
  @Input() allowsMultiSelection: boolean = false;
  @Input() showPopupOnAddEdit: boolean = true;

  @Output() onAdd: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDeleteInline: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEditInline: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCancelDetail: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCustomButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCustomInlineButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() onItemClick: EventEmitter<any> = new EventEmitter<any>();

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/dataTable/dataTable.component.ts